import React, {useEffect} from "react";
import {useNavigate, useLocation} from "react-router-dom";
import {useAuth} from "./AuthContext";
import {CredentialResponse, GoogleLogin, GoogleOAuthProvider} from "@react-oauth/google";
import { AuthResponse } from "../Types/Auth";
import LoginImage from "../Images/login_image.jpg";
import styles from "./LoginPage.module.css";
import {setItemWithExpiry, setJwt} from "./Auth";

const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID ?? "";

const Login: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { login, token } = useAuth();

    useEffect(() => {
        if (token) {
            const from = (location.state as any)?.from?.pathname || "/";
            navigate(from, {replace: true});
        }
    }, [token, navigate, location.state]);


    const handleSuccess = async (credentialResponse: CredentialResponse) => {
        if (!credentialResponse.credential) {
            return;
        }

        const res = await fetch(process.env.REACT_APP_API_BASE_URL + "/api/v1/auth/google", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ idToken: credentialResponse.credential }),
        });

        if (res.ok) {
            const data: AuthResponse = await res.json();
            login(data.jwt, data.expiresIn);
            navigate("/", { replace: true });
        } else {
            alert("Not Authorized!");
        }
    };

    return (
        <div className={styles.container}>
            <div className={styles.left}>
                <h1>Please Log In</h1>
                <GoogleOAuthProvider clientId={clientId}>
                    <div className={styles['google-login-wrapper']}>
                        <GoogleLogin onSuccess={handleSuccess} onError={() => console.error("Failed to login with Google")} />
                    </div>
                </GoogleOAuthProvider>
            </div>
            <div className={styles.right}>
                <img src={LoginImage} alt="Login Visual"></img>
            </div>
        </div>
    )
}

export default Login;